// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import { handleUpload } from "utils/ImageUploader";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SoftImageInput from "components/SoftImageInput";

function ProductImage({ onChange, defaultImage }) {
  const { t } = useTranslation();

  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setLoading(true);
      const imageUrl = await handleUpload(file);
      setImage(imageUrl);
      onChange({ product_image: imageUrl });
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ height: "100%" }}>
      <SoftImageInput
        label={t("Image du produit")}
        image={image || defaultImage}
        onChange={handleImageUpload}
        onClear={() => {
          setImage("");
          onChange({ product_image: "" });
        }}
        loading={loading}
      />
    </Card>
  );
}

export default ProductImage;
